import { isRunningInAppShell } from './utils/appShell';

// Async entry point for Module Federation
// Only load bootstrap in standalone mode, not when consumed as a remote
if (!isRunningInAppShell()) {
  import('./bootstrap');
}

